import React from 'react'
import { SpinnerContainer } from '../../assets/styles/components/dashboardPage/Spinner.styles'

export default function Spinner() {
	return (
		<SpinnerContainer>
			<div className='loader'></div>
		</SpinnerContainer>
	)
}
